export const deleteSessionCookie = (name: string): void => {
    document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC; samesite=strict`;
  };
  
  export const getSessionCookie = (name: string): string | null => {
    const cookies = document.cookie.split('; ');
    for (const cookie of cookies) {
        const [key, val] = cookie.split('=');
        if (key === name) {
            return val;
        }
    }
    return null;
  };
  
  export const setSessionCookie = (name: string, value: string): void => {
    if (getSessionCookie(name)) return;
    document.cookie = `${name}=${value}; path=/; samesite=strict`;
  };
  
  export const setAppSessionStart = (): void => {
      if (!getSessionCookie('app_session_start')) {
          setSessionCookie('app_session_start', Date.now().toString());
      }
  };
  
  export const getAppSessionStart = (): number | null => {
      const startTime = getSessionCookie('app_session_start');
      return startTime ? parseInt(startTime, 10) : null;
  };
  
  export const clearAppSessionStart = (): void => {
      deleteSessionCookie('app_session_start');
  };
  
  export const calculateSessionDuration = (): string | undefined => {
      const startTime = getAppSessionStart();
      clearAppSessionStart();
      if (!startTime) return;
      const rawMinutes = (Date.now() - startTime) / 60000;
      const minutes = Math.floor(rawMinutes);
      const seconds = Math.round((rawMinutes - minutes) * 60);
      return `${minutes} мин. ${seconds} сек.`; // Время в минутах
  };
  